import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
@Injectable({
  providedIn: 'root'
})
export class SharedService {
  readonly APIUrl = this.appSettings.getServerURL();
  private empId = new BehaviorSubject<number>(0);
  private empId2 = new BehaviorSubject<number>(0);
  CurrentEmpId = this.empId.asObservable();
  CurrentEmpId2 = this.empId2.asObservable();
  private employee = new BehaviorSubject<number>(0);
  currentEmployee = this.employee.asObservable();
  constructor(private http: HttpClient, private appSettings: AppConfigService) { }
  errorHandler(error: HttpErrorResponse) {
    return Observable.throw(error.message || "Server Error");
  }
  //EMPLOYEE APIS
  GetEmpList(): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/employee');
  }
  GetEmployee(val: any): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/employee/id/' + val);
  }
  GetEmployeeByEmail(email: string): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/employee/email/' + email);
  }
  AddEmployee(val: any) {
    return this.http.post(this.APIUrl + '/Employee', val);
  }
  UpdateEmployee(val: any) {
    return this.http.put(this.APIUrl + '/Employee', val);
  }
  DeleteEmployee(val: any) {
    return this.http.delete(this.APIUrl + '/Employee/' + val);
  }
  //ATTENDANCE APIS
  GetAttendanceList(): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/Attendance');
  }
  GetAllEmployeeAttendance(val: number): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/Attendance/' + val)
  }
  GetEmployeeAttendance(date: Date, id: number): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/Attendance/' + id + '/' + date)
  }
  GetEmployeeAttendanceForYear(id: number, year: number): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/Attendance/year/' + id + '/' + year)
  }
  AddAttendance(val: any) {
    return this.http.post(this.APIUrl + '/Attendance', val);
  }
  UpdateAttendance(val: any) {
    return this.http.put(this.APIUrl + '/Attendance', val);
  }
  DeleteAttendance(val: any) {
    return this.http.delete(this.APIUrl + '/Attendance/' + val);
  }
  //EMPLOYEE -> ATTENDANCE
  ChangeEmpId(Id: number) {
    this.empId.next(Id);
  }
  //EMPLOYEE -> REPORT
  ChangeEmpId2(Id: number) {
    this.empId2.next(Id);
  }
  //EMPLOYEE -> MAIN
  ChangeEmployee(emp: any) {
    this.employee.next(emp);
  }
  //CALENDAR APIs
  GetCurrentMonth(month: number, year: number): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/Calendar/' + month + '/' + year);
  }
  GetDayDetails(val: Date): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/Calendar/' + val);
  }
  GetYear(val: number): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/Calendar/year/' + val);
  }
  //LEAVE APIs
  GetMonthLeaves(): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/EmployeeLeave');
  }
  GetMonthlyLeaves(month: number, year: number): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/EmployeeLeave/' + 1 + '/' + month + '/' + year);
  }
  GetEmployeeLeaveForDay(id: number, date: Date): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/EmployeeLeave/day/' + id + '/' + date);
  }
  GetEmployeeLeaveForYear(id: number, year: number): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/EmployeeLeave/year/' + id + '/' + year);
  }
  AddEmployeeLeave(val: any) {
    return this.http.post(this.APIUrl + '/EmployeeLeave', val);
  }
  UpdateEmployeeLeave(val: any) {
    return this.http.put(this.APIUrl + '/EmployeeLeave', val);
  }
  ChangeLeaveType(val: any) {
    return this.http.put(this.APIUrl + '/EmployeeLeave/change', val);
  }
  //COMPENSATION APIs
  GetMonthCompensations(): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/Compensation');
  }
  GetEmployeeCompensationsForMonth(id: number, date: Date): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/Compensation/' + id + '/' + date);
  }
  AddCompensation(val: any) {
    return this.http.post(this.APIUrl + '/Compensation', val);
  }
  //EXCEL APIs
  UploadExcel(file: FormData) {
    console.log(file)
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    const httpOptions = { headers: headers };
    return this.http.post(this.APIUrl + '/Excel/Post', file, httpOptions)
  }
  GetExcelData() {
    return this.http.get("https://localhost:44333/Excel/Get")
  }
  //CLOCKIFY APIs
  GetClockifyContacts(id: any, startDate: any, endDate: any) {
    let StartDate = '2021-03-30T00:00:00Z';
    let EndDate = '2021-03-31T00:00:00Z';// new Date().toISOString();
    let params = new HttpParams().set('id', id).set('start', startDate).set('end', endDate);
    return this.http.get(this.APIUrl + '/Clockify/Get', { params: params });
  }
  GetClockifyAllUsers() {
    return this.http.get(this.APIUrl + '/Clockify/GetAllUsers');
  }
  PostClockifyContacts(val: any) {
    const headers = new HttpHeaders();
    //console.log(val)
    headers.append('Content-Type', 'application/json');
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    headers.append('Content-Type', 'XMLHttpRequest');
    return this.http.post(this.APIUrl + '/Clockify/Post', val, { 'headers': headers })
  }
  PostClockifyFilter() {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    headers.append('Content-Type', 'XMLHttpRequest');
    return this.http.post(this.APIUrl + '/Clockify/PostClockifyFilter', { 'headers': headers })
  }
  GetClockifyData(month: number, year: number): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/Clockify/month/' + month + '/' + year);
  }
  GetClockifyDataForYear(id: string, year: number): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/Clockify/year/' + id + '/' + year);
  }
  DeleteClockify(val: any) {
    return this.http.delete(this.APIUrl + '/Clockify/' + val);
  }
  DeleteTaskBeforeImport(clockifyId: any, date: Date) {
    return this.http.delete(this.APIUrl + '/Clockify/task1/' + clockifyId + '/' + date);
  }
  DeleteClockifyBeforeImport(clockifyId: any, date: Date) {
    return this.http.delete(this.APIUrl + '/Clockify/clockify1/' + clockifyId + '/' + date);
  }
  DeleteTaskMonth(month: number, year: number) {
    return this.http.delete(this.APIUrl + '/Clockify/taskMonth/' + month + '/' + year);
  }
  DeleteClockifyMonth(month: number, year: number) {
    return this.http.delete(this.APIUrl + '/Clockify/clockifyMonth/' + month + '/' + year);
  }
  //SETTING APIs
  GetSetting(id: any): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/LeaveSetting/' + id);
  }
  UpdateLastImportDate(id: any, month: number, year: number) {
    return this.http.put(this.APIUrl + '/LeaveSetting/import/' + id + '/' + month + '/' + year, { id, month, year });
  }
  UpdateLastSummaryDate(id: any, month: number, year: number) {
    return this.http.put(this.APIUrl + '/LeaveSetting/summary/' + id + '/' + month + '/' + year, { id, month, year });
  }
  //SUMMARY APIs
  GetSummariesForMonth(month: number, year: number): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/Summary/month/' + month + '/' + year);
  }
  GetSummariesForYear(id: number, year: number): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/Summary/year/' + id + '/' + year);
  }
  AddSummary(val: any) {
    return this.http.post(this.APIUrl + '/Summary', val);
  }
  //SENDGRID APIs
  SendEmail(email: any) {
    return this.http.post(this.APIUrl + '/Email', email);
  }
  //CHANGE REQUEST APIs
  GetAllRequests(): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/ChangeRequest');
  }
  GetEmployeeRequests(id: number): Observable<any[]> {
    return this.http.get<any>(this.APIUrl + '/ChangeRequest/employee/' + id);
  }
  AddChangeRequest(request: any) {
    return this.http.post(this.APIUrl + '/ChangeRequest', request);
  }
  UpdateChangeRequest(request: any) {
    return this.http.put(this.APIUrl + '/ChangeRequest', request);
  }
  DeleteEmployeeLeaveForMonth(month: number, year: number) {
    return this.http.delete(this.APIUrl + '/EmployeeLeave/employeeLeave/' + month + '/' + year);
  }
  DeleteCompensationForMonth(month: number, year: number) {
    return this.http.delete(this.APIUrl + '/Compensation/compensationMonth/' + month + '/' + year);
  }
}